
<div class="row text-center mt-5">
  <div class="col-lg-6 col-offset 2">
    <a class = 'btn btn-success text-center' routerLink='/home'>Country Wise</a>
  </div>
  <div class="col-lg-6 col-offset 2">
    <a class = 'btn btn-danger text-center' routerLink = '/countries/India'>India</a>
  </div>
</div>

<img src="https://covid19.mathdro.id/api/og" height = "50%" width = "auto" class = "mt-5 mb-5 ml-5 mr-5 img-fluid" alt="">
